import React from 'react';
import Collapse from 'components/Collapse/Collapse';
import { IFAQ } from './types';
import css from './Faq.module.scss';
import './ant.scss';
import dropDownArrow from 'static/img/dropDownArrow.svg';
import cn from 'classnames';

const { Panel } = Collapse;

function FAQ({
  faq,
  hideTitle,
  noPadding,
  classes = {}
}: {
  faq: IFAQ[];
  hideTitle?: boolean;
  noPadding?: boolean;
  classes?: {
    title?: string;
    text?: string;
    block?: string;
    wrapper?: string;
  }
}) {
  return (
    <div className={cn(css.wrapper, classes.wrapper)}>
      {!hideTitle && (
        <div className={css.title}>Frequently Asked Questions</div>
      )}
      <div
        className={cn(css.questionList, {
          [css.noPadding]: noPadding
        })}
      >
        <Collapse
          className={cn('ant-question-list', classes.block)}
          expandIconPosition="right"
          bordered={false}
          expandIcon={({ isActive }) => (
            <img
              src={dropDownArrow}
              style={{ transform: `rotate(${isActive ? 0 : 180}deg)` }}
              alt=""
            />
          )}
        >
          {faq.map(el => (
            <Panel key={el.name} header={el.name} className={classes.title}>
              {Array.from(el.text).map((t, index) => (
                <div className={cn(css.paragraph, classes.text)} key={index}>
                  {t}
                </div>
              ))}
            </Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
}

export default FAQ;
